import { getStatusComandaItemDescricao, StatusComandaItem } from "./StatusComandaItem";

//comandas/ComandaItem.js
export class ComandaItem {
  constructor() {
    this.id = 0;
    this.comandaId = 0;
    this.item = 0;
    this.produtoId = 0;
    this.xProd = '';
    this.produto = null;
    this.status = StatusComandaItem.Aberto; // usando enum
    this.qtde = 0;
    this.valorUnitario = 0;
    this.valorPago = 0;
    this.pedidoId = 0;
    this.dataCad = null;
  }

  get valorRestante() {
    return this.valorTotal - this.valorPago;
  }

  get valorTotal() {
    return this.qtde * this.valorUnitario;
  }

  get statusDescricao() {
    return getStatusComandaItemDescricao(this.status);
  }
}